import { GetContextMenuItemsParams, GridApi } from 'ag-grid-enterprise';
import { Subject } from 'rxjs';

import { ContextMenuItemComponent } from '../components/templates/context-menu-item/context-menu-item.component';
import { InsertPosition } from '../services/dto/insert-position';
import { RowType } from '../services/dto/row-type';
import { ContentMenuAction, ContentMenuActionType } from './types';

export class CamGridContextMenu<T extends { id: string }> {
  public contextMenuAction$ = new Subject<{
    action: ContentMenuActionType | 'openInExternalLink' | 'separator';
    item: T;
    position?: InsertPosition;
    targetType?: RowType;
  }>();

  public setup(api: GridApi<T>, contextMenuItems?: ContentMenuAction[]) {
    if (!contextMenuItems || contextMenuItems.length === 0) {
      api.setGridOption('suppressContextMenu', true);
      return;
    }

    api.setGridOption(
      'getContextMenuItems',
      (contextParams: GetContextMenuItemsParams) =>
        contextMenuItems.map(item => {
          if (typeof item === 'string') {
            return {
              action: () => this.contextMenuAction$.next({ action: item, item: contextParams.node?.data }),
              icon: 'arrow-go-forward-line',
              menuItem: ContextMenuItemComponent,
              name: `grid.context-menu-item.${item}`,
            };
          }
          const resolvedName =
            typeof item.name === 'function' ? item.name(contextParams.node?.data, contextParams.node) : item.name;
          const resolvedIcon =
            typeof item.icon === 'function'
              ? item.icon(contextParams.node?.data, contextParams.node)
              : (item.icon ?? 'arrow-go-forward-line');
          if (item.subMenu?.length) {
            return {
              disabled: item.disabled ? item.disabled(contextParams.node?.data, contextParams.node) : false,
              icon: resolvedIcon,
              menuItem: ContextMenuItemComponent,
              name: resolvedName,
              subMenu: item.subMenu.map(sub => ({
                action: () =>
                  this.contextMenuAction$.next({
                    action: item.action,
                    item: contextParams.node?.data,
                    position: sub.position,
                    targetType: sub.targetType,
                  }),
                disabled: sub.disabled ? sub.disabled(contextParams.node?.data, contextParams.node) : false,
                icon: sub.icon,
                menuItem: ContextMenuItemComponent,
                name: sub.name,
              })),
            };
          }
          return {
            action: () => this.contextMenuAction$.next({ action: item.action, item: contextParams.node?.data }),
            disabled: item.disabled ? item.disabled(contextParams.node?.data, contextParams.node) : false,
            icon: resolvedIcon,
            menuItem: ContextMenuItemComponent,
            name: resolvedName,
          };
        }) ?? []
    );
  }
}
